import { FormikProps, useFormik } from 'formik';
import { ModalStep, } from '../hooks';

import {  Dispatch, SetStateAction } from 'react';

export type SelectBankType = {
  bankName : string,  
};

export type SelectBranchType = {
  branchName : string,  
};

export const useSelectBank = (setModalStep : Dispatch<SetStateAction<ModalStep>>, onSelectedBank : (value : string) => void,) => {

    const initialValues: SelectBankType = {
      bankName : '',
    };
  
    const formik: FormikProps<SelectBankType> = useFormik<SelectBankType>({
      initialValues,
      onSubmit: async (input) => {
        //apiリクエスト...問題が無ければ次へ
        await onSelectedBank(input.bankName);
        setModalStep(ModalStep.SearchBranch)
      },
      // validationSchema: advanceQuestionValidation,
      validateOnChange: false,
      validateOnBlur: false,
    });

    //props
    const selectedBankProps = {
      value: formik.values.bankName,
      key: 'bankName',
      onClick : (value : string) => formik.setFieldValue('bankName', value),
      back : () => setModalStep(ModalStep.SearchBank),
      disabled: !(!!formik.values.bankName),
      error: formik.errors.bankName,
    }

    return {
      formik,
      selectedBankProps,
    }
};

export const useSelectBranch = (setModalStep : Dispatch<SetStateAction<ModalStep>>, onClosed : () => void, onSelectedBranch : (value : string) => void) => {

  const initialValues: SelectBranchType = {
    branchName : '',
  };

  const formik: FormikProps<SelectBranchType> = useFormik<SelectBranchType>({
    initialValues,

    onSubmit: async (input) => {
      //apiリクエスト...問題が無ければ次へ
      await onSelectedBranch(input.branchName);
      onClosed();
    },
    // validationSchema: advanceQuestionValidation,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const selectedBranchProps = {
    value: formik.values.branchName,
    key : 'branchName',
    onClick : (value : string) => formik.setFieldValue('branchName', value),
    back : () => setModalStep(ModalStep.SearchBranch),
    disabled: !(!!formik.values.branchName),
    error: formik.errors.branchName,
  }

  return {
    formik,
    selectedBranchProps,
  }
};
